module.exports = __webpack_public_path__ + "static/img/ru.14814a48.svg";